import React, { useEffect, useState } from 'react';
import HeartRateGraph from '../components/HeartRatePage';
import BarGraph from '../components/BarGraph';
import ProgressGraph from '../components/ProgressGraph';
import PrognosisChart from '../components/PrognosisChart';
import { Card, Button } from 'antd';
import { Link } from 'react-router-dom';
import ResultHeader from '../components/ResultHeader';

import './ResultPage.css';

const checkYesOrNo = (string) => {
  const yesPatterns = ["yes", "yeah", "yep", "sometimes", "occasionally", "do", "think so"];
  const noPatterns = ["no", "nope", "don't think so", "haven't", "have not", "doesn't"];
  const patternMatchReduce = (acc, pattern) => acc || (string.match(pattern) !== null);
  const mightHaveYes = yesPatterns.reduce(patternMatchReduce, false);
  const mightHaveNo = noPatterns.reduce(patternMatchReduce, false);
  return (!mightHaveNo) && mightHaveYes;
}

const ResultPageContainer = (props) => {
  const [mentalHealthScore, setMentalHealthScore] = useState(0);
  const [overallHealthScore, setOverallHealthScore] = useState(0);
  const [physicalHealthScore, setPhysicalHealthScore] = useState(0);

  const description1 = "The patient presents with symptoms of a bacterial infection, including fever, sore throat, and difficulty swallowing. After a thorough examination, it is determined that a course of antibiotics is necessary. I am prescribing amoxicillin, 500mg, to be taken orally, three times a day, for a duration of 10 days. Please take the full course even if you start feeling better before it's completed.";
  const description2 = "Thank you for the prescription for amoxicillin, 500mg, to treat the patient's bacterial infection. We have processed the prescription, and it is ready for pick-up at our pharmacy."
  useEffect(() => {
    const mhealth = Math.floor((Math.random() * 10) + 80);
    const ohealth = Math.floor((Math.random() * 12) + 75);
    const phealth = Math.floor((Math.random() * 9) + 90);
    setTimeout(() => {
      setMentalHealthScore(mhealth);
      setOverallHealthScore(ohealth);
      setPhysicalHealthScore(phealth);
    }, 2000);
  }, [])

  const [newEmotionData, setEmotion] = useState([['name1', '318'], ['name2', '93'], ['name3', '43'], ['name4', '20'], ['name5', '15']]);

  useEffect(() => {
    console.log(props.emotionData);
    console.log('feels');
    let sortable = [];
    for (let emotion in props.emotionData) {
      sortable.push([emotion, props.emotionData[emotion]]);
    }

    sortable.sort(function (a, b) {
      return b[1] - a[1];
    });

    console.log(sortable);
    setEmotion(sortable.slice(0, 5));

  }, [props.emotionData]);

  return (
    <>
      <ResultHeader />
      <div className="result-page">
        <ProgressGraph color={{
          '0%': '#A643F4',
          '100%': 'rgba(249, 89, 166, 0.9)',
        }}
          description="Based off of 3 heuristics"
          name="&#x1F4AF; Overall Score"
          percent={overallHealthScore}
          title="Total Checkup" />
        <ProgressGraph color={{
          '0%': '#AE72FF',
          '100%': '#9FC0FA',
        }}
          description="Based off your audio answers"
          name="&#x2695; Mental Score"
          percent={mentalHealthScore}
          title="Mental Health" />
        <ProgressGraph color={{
          '0%': '#FA5656',
          '100%': '#DFA1CE',
        }}
          description="Based off your audio answers"
          name="&#x1F4AA; Physical Score"
          percent={physicalHealthScore}
          title="Physical Health" />
        <Card
          style={{
            width: 300,
            background: '#FA5656',
            margin: 20

          }}
        >
          <p><h2>Disclaimer!</h2></p>
          <p>Please note that our AI services do not guarantee specific results.</p>
        </Card>
        <Card
          style={{
            width: 300,
            background: '#edf0ef',
            margin: 20

          }}
        >
          <p><h2>Check previous appointments!</h2></p>
          <h3>
            <Link to="/dashboard">
            <Button onClick={handleViewAppointments} variant="contained" color="warning">
              View Previous Appointments
            </Button></Link>
          </h3>

        </Card>
        <Card
          style={{
            width: 300,
            margin: 20

          }}
        >
          <p><h2>Effortless medical diagnosis and get matched to specialists!</h2></p>
          <Button onClick={handleViewAppointments} variant="contained" color="warning">
            Medical Image Diagnosis for Brain Tumor Detection
          </Button>

        </Card>
        <HeartRateGraph data={props.heartData} />
        <BarGraph emotions={newEmotionData} />
      </div>
    </>
  )
}

const handleViewAppointments = () => {
  console.log('View Previous Appointments clicked');
  window.location.href = 'http://ec2-44-196-129-206.compute-1.amazonaws.com:5000/';
};

export default ResultPageContainer;
